<!-- eslint-disable vue/valid-v-for -->
<template>
	<div>
		<b-row>
			<b-col cols="12">
				<div class="d-flex justify-content-between mb-2">
					<h3>CCRIS Items</h3>
					<el-button type="info" size="mini" icon="el-icon-refresh-left" @click="$refs.fullCommitment.show()" v-if="!_gHlp.isEmpty(activeCreditReport)" >Full View Loan Information</el-button>
				</div>
			</b-col>
		</b-row>
		<b-card no-body v-loading="is_loading">
			<div class="table-listings">
				<el-table ref="ccrisTable" style="width: 100%" size="small" show-summary
					:data="tableData" :header-cell-class-name="'text-13px'" :summary-method="getSummaries">
					<!-- CHECKBOX -->
					<!-- <el-table-column v-if=" _gHlp.checkAccess(allowAssignRoles)" type="selection" class-name="pb-3" width="55" fixed></el-table-column> -->
					<el-table-column type="index" width="50" class-name="text-center font-weight-bold"></el-table-column>

					<el-table-column label="Date/ R&R" min-width="140" prop="approved_date" sortable has_summary>
						<template slot-scope="scope">
							<p>{{ scope.row.approved_date | dateFormatString }}</p>
						</template>
					</el-table-column>

					<el-table-column label="Capacity" min-width="120" prop="capacity" sortable>
						<template slot-scope="scope">
							<p>{{ scope.row.capacity }}</p>
						</template>
					</el-table-column>

					<el-table-column label="Bank Name" min-width="160" prop="bank_id" sortable>
						<template slot-scope="scope">
							<b-form-select v-model="scope.row.bank_id" size="sm"
								:disabled="isViewOnly">
								<b-form-select-option v-for="item in banksOptions" :key="item.bank_id" :value="item.bank_id">{{
									item.name }}</b-form-select-option>
							</b-form-select>
						</template>
					</el-table-column>

					<el-table-column label="Facility" min-width="130" prop="loan_statue" sortable>
						<template slot-scope="scope">
							<p>{{ scope.row.loan_statue }}</p>
						</template>
					</el-table-column>

					<el-table-column label="Sts" min-width="80" prop="sts" sortable>
						<template slot-scope="scope">
							<p>{{ scope.row.sts }}</p>
						</template>
					</el-table-column>

					<el-table-column label="Limit" min-width="150" prop="credit_limit" sortable class-name="text-right">
						<template slot-scope="scope">
							<p>{{ scope.row.credit_limit | moneyFormatter }}</p>
						</template>
					</el-table-column>

					<el-table-column label="Outstanding" min-width="150" prop="current_outstanding" sortable
						class-name="text-right">
						<template slot-scope="scope">
							<p>{{ scope.row.current_outstanding | moneyFormatter }}</p>
						</template>
					</el-table-column>

					<el-table-column label="Instalment" min-width="150" prop="current_installment" sortable
						class-name="text-right">
						<template slot-scope="scope">
							<p>{{ scope.row.current_installment | moneyFormatter }}</p>
						</template>
					</el-table-column>

					<el-table-column label="Settlement" min-width="150" prop="invinity_solution" sortable>
						<template slot-scope="scope">
							<CurrencyInput className="text-right" v-model="scope.row.invinity_solution" size="sm" :disabled="!scope.row.is_settled || isViewOnly"
								:options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
						</template>
					</el-table-column>

					<el-table-column label="Final Commitment" min-width="150" prop="final_installment" sortable>
						<template slot="header">
							Final<br />Commitment
						</template>
						<template slot-scope="scope">
							<CurrencyInput className="text-right" v-model="scope.row.final_installment" size="sm" :disabled="!scope.row.is_settled || isViewOnly"
								:options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
						</template>
					</el-table-column>

					<el-table-column label="Settle" min-width="100" prop="is_settled" sortable>
						<template slot-scope="scope">
							<el-switch v-model="scope.row.is_settled" active-color="#099A78"
								@change="handleChangeSettle(scope.row, scope.$index)" :disabled="isViewOnly"></el-switch>
						</template>
					</el-table-column>

				</el-table>
			</div>
			<div class="text-right p-2" v-if="!isViewOnly">
				<el-button type="warning" class="mx-1" size="mini" @click="submitAndCalculate" icon="el-icon-circle-check">Save & Calculate</el-button>
			</div>
		</b-card>
		<FullCommitment ref="fullCommitment"/>
	</div>
</template>
<script>
import {cloneDeep, isEqual} from 'lodash'
import { Switch, Table, TableColumn, Select, Option, Button } from 'element-ui';
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
import CurrencyInput from '@/components/CurrencyInput';
import FullCommitment from '@/views/CustomerProfile/Modals/FullCommitment'
import { mapState, mapActions } from 'pinia';
import { useCommonStore } from '@/stores/commonStore';
import { useCustomerStore } from '@/stores/customerStore';
import { useCreditReportStore } from '@/stores/creditReportStore';

export default {
	props: ['is-view-only'],
	components: {
		CurrencyInput,
		FullCommitment,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Button.name]: Button,
		[Switch.name]: Switch,
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			is_loading_rows: [],
			oldTableData: [],
			tableData: [],
			tableSummary: {},
			tableColumnSkipSummary: [0, 1, 2, 3, 4, 5, 11],
			formData:{
				ccrisItemsSettleList:[],
				ccris_commitment:0,
				ccris_settlement:0,
				final_installment:0,
			},
			banksOptions: []
		}
	},
	created() {
		this.getBanks();
		this.initComponent();
	},
	beforeDestroy() {
		this.clearComponent()
	},
	beforeUnmount(){
		this.clearComponent()
	},
	computed: {
		...mapState(useCustomerStore, ['activeLoanECCcriss', 'getActiveLoanECCcriss', 'activeLoanEC', 'getActiveLoanEC','activeFormLoanEc']),
		...mapState(useCreditReportStore, ['activeCreditReport']),
		is_loading(){
			return _gHlp.isLoading('fetch_ccris_items') || _gHlp.isLoading('fetch_loan_ec')
		}
	},
	watch: {
		activeFormLoanEc: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.formData = { ...this.formData, ...newVal }
				}
			},
			immediate: true
		},
		activeLoanECCcriss: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.initComponent();
				}
			},
			immediate: true
		},
		tableSummary: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.callbackTableSummary(newVal);
				}
			},
			immediate: true
		}
	},
	methods: {
		...mapActions(useCommonStore, ['getTables']),
		...mapActions(useCustomerStore, ['getCCRISCommitmentList', 'createOrUpdateCCRISItems','setFormLoanEc']),
		clearComponent(){
			this.is_loading_rows = []
			this.oldTableData = []
			this.tableData = []
			this.tableSummary = {}
			this.formData = {
				ccrisItemsSettleList:[],
				ccris_commitment:0,
				ccris_settlement:0,
				final_installment:0,
			}
		},
		initComponent() {
			_gHlp.setLoading('fetch_ccris_items')
			this.fetcAllRelations(this.activeLoanECCcriss)
		},
		fetcAllRelations(resp){
			this.tableData = [];
			if (!_gHlp.isEmpty(resp) && !_gHlp.isEmpty(resp.data)) {
				this.tableData = resp.data.map(itm => ({
					...itm,
					is_settled: (itm.is_include == 1)
				}));
			}
			this.setOldData()
			_gHlp.removeLoading('fetch_ccris_items')
		},
		setOldData(){
			this.oldTableData = cloneDeep(this.tableData)
		},
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			const cbData = [];

			columns.forEach((column, index) => {
				if (index === 4) {
					sums[index] = 'Total';
					return;
				}
				if (this.tableColumnSkipSummary.includes(index)) {
					return;
				}

				const values = data.map(item => {
					return Number(item[column.property])
				});
				if (!values.every(value => isNaN(value))) {
					const total = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);

					sums[index] = 'RM ' + total.toLocaleString('en-MY', { minimumFractionDigits: 2 });
					cbData[column.property] = total
				} else {
					sums[index] = '';
				}
			});

			//callback
			this.tableSummary = cbData;
			return sums;
		},
		callbackTableSummary(data, save=false) {
			this.formData.ccrisItemsSettleList = [];
			let settleItems = this.tableData.filter((item) => { return item.is_include == 1 })
			for (let idx = 0; idx < settleItems.length; idx++) {
				const newData = {...settleItems[idx],...this.getParams(settleItems[idx])}
				this.formData.ccrisItemsSettleList.push(newData)
			}
			this.formData.ccris_commitment = !_gHlp.isEmpty(data) ? parseFloat(data.current_installment) : 0;
			this.formData.ccris_settlement = !_gHlp.isEmpty(data) ? parseFloat(data.invinity_solution) : 0;
			this.formData.final_installment = !_gHlp.isEmpty(data) ? parseFloat(data.final_installment) : 0;
			this.setFormLoanEc(this.formData)
			this.$emit('change',save);
		},
		getBanks() {
			this.getTables('banks').then(resp => {
				this.banksOptions = resp.banks;
			});
		},
		handleChangeSettle(item, index) {
			if (item.is_settled) {
				item.invinity_solution = item.current_outstanding;
				item.final_installment = 0;
				item.is_include = 1;
			} else {
				item.is_include = 0;
				item.invinity_solution = 0;
				item.final_installment = item.current_installment;
			}
			this.tableData[index] = item;
		},
		getParams(item) {
			if(_gHlp.isEmpty(item)) return {}
			const bank = this.banksOptions.find(bnk => bnk.bank_id == item.bank_id)
			return {
				bank_id: item.bank_id,
				bank_name: _gHlp.getValue(bank,'name',null),
				bank_code: _gHlp.getValue(bank,'code',null),
				invinity_solution: item.invinity_solution,
				final_installment: item.final_installment,
				is_include: item.is_include,
				// capacity: item.capacity,
				// approved_date: item.approved_date,
				// sts: item.sts,
				// loan_statue: item.loan_statue,
				// remark: item.remark,
				// credit_limit: item.ccris_sum_credit_limit,
				// current_outstanding: item.ccris_sum_current_outstanding,
				// current_installment: item.ccris_sum_current_installment,
				id: item.id
			}
		},
		submitAndCalculate(){
			let updateItems = [];
			for (let idx = 0; idx < this.tableData.length; idx++) {
				const newData = this.getParams(this.tableData[idx])	
				const oldData = this.getParams(this.oldTableData.find(itm => itm.id === newData.id));
				if(_gHlp.isEmpty(oldData) || !isEqual(newData, oldData)) {
					updateItems.push(this.createOrUpdateCCRISItems(newData));
				}
			}
			
			if(!_gHlp.isEmpty(updateItems)){
				_gHlp.setLoading('fetch_ccris_items')
				Promise.all(updateItems)
				.then(res  => {
					this.callbackTableSummary(this.tableSummary,true)
					this.setOldData()
					_gHlp.removeLoading('fetch_ccris_items')
				})
				.catch(e => {
					_gHlp.removeLoading('fetch_ccris_items')
				})
			}
		}
	}
}
</script>